function updateCharCounter() {
  const remainingChars = 300 - $(this).val().length;
  $("#description-chars-remaining").html(remainingChars);
}

$(document).on("keyup", "#profileDescription", updateCharCounter);
$(document).on("keypress", "#profileDescription", updateCharCounter);
